var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflowSetting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.30469H4.16667C3.24619 3.30469 2.5 4.05088 2.5 4.97135V8.30469C2.5 9.22516 3.24619 9.97135 4.16667 9.97135H7.5C8.42047 9.97135 9.16667 9.22516 9.16667 8.30469V4.97135C9.16667 4.05088 8.42047 3.30469 7.5 3.30469Z",
    stroke: "#67768E",
    strokeWidth: 1.22144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 9.97266V13.306C5.83337 13.748 6.00897 14.1719 6.32153 14.4845C6.63409 14.7971 7.05801 14.9727 7.50004 14.9727H10.8334",
    stroke: "#67768E",
    strokeWidth: 1.22144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 11.6367H12.5C11.5796 11.6367 10.8334 12.3829 10.8334 13.3034V16.6367C10.8334 17.5572 11.5796 18.3034 12.5 18.3034H15.8334C16.7538 18.3034 17.5 17.5572 17.5 16.6367V13.3034C17.5 12.3829 16.7538 11.6367 15.8334 11.6367Z",
    stroke: "#67768E",
    strokeWidth: 1.22144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowSetting);
export default __webpack_public_path__ + "static/media/WorkflowSetting.f5a067fd5c7d05de16ec3a8d0f9583f5.svg";
export { ForwardRef as ReactComponent };